import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, CheckCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useSelection } from '../contexts/SelectionContext';

export const DiamondCard = ({ diamond, showPrice = false }) => {
  var IMGURL = "https://justinndiam.com:8000";
  const { user } = useAuth();
  const { isSelected, toggleDiamond } = useSelection();
  const isApproved = user?.status === 'approved' || user?.role === 'admin';
  const canViewPrice = showPrice && isApproved;
  const selected = isSelected(diamond.diamond_id);

  const handleCheckboxClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleDiamond(diamond);
  };

  return (
    <div className="relative">
      {/* Selection Checkbox */}
      <div 
        className="absolute top-4 right-4 z-10 cursor-pointer"
        onClick={handleCheckboxClick}
        data-testid={`select-diamond-${diamond.diamond_id}`}
      >
        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
          selected 
            ? 'bg-primary text-white' 
            : 'bg-white/90 border-2 border-border hover:border-primary'
        }`}>
          {selected && <CheckCircle size={20} />}
        </div>
      </div>

      <Link 
        to={`/diamonds/${diamond.diamond_id}`} 
        className="bg-white border border-border/50 hover:border-primary/50 transition-all duration-300 hover:-translate-y-1 p-8 group block"
        data-testid={`diamond-card-${diamond.diamond_id}`}
      >
        <div className="aspect-square bg-surface mb-6 overflow-hidden relative">
          {diamond.images && diamond.images.length > 0 ? (
            <img 
              src={IMGURL+diamond.images[0]} 
              alt={`${diamond.shape} diamond`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-muted-foreground">
              <Eye size={48} />
            </div>
          )}
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="font-heading text-lg font-semibold">{diamond.shape}</span>
            <span className="font-mono text-sm tabular-nums">{diamond.size} ct</span>
          </div>

          {diamond.stock_id && (
            <div className="text-xs text-muted-foreground">
              Stock ID: <span className="font-mono font-semibold text-foreground">{diamond.stock_id}</span>
            </div>
          )}

          <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground">
            <div>Color: <span className="text-foreground font-medium">{diamond.colour}</span></div>
            <div>Clarity: <span className="text-foreground font-medium">{diamond.clarity}</span></div>
            <div>Cut: <span className="text-foreground font-medium">{diamond.cut}</span></div>
            <div>Lab: <span className="text-foreground font-medium">{diamond.lab}</span></div>
          </div>

          {canViewPrice && diamond.total_amount ? (
            <div className="pt-4 border-t border-border/30">
              <div className="flex items-end justify-between">
                <span className="text-xs uppercase tracking-widest text-muted-foreground">Total</span>
                <span className="font-mono text-xl font-bold text-primary tabular-nums">${diamond.total_amount.toLocaleString()}</span>
              </div>
              <div className="text-xs text-muted-foreground mt-1 tabular-nums">
                ${diamond.price_per_carat}/ct
              </div>
            </div>
          ) : (
            <div className="pt-4 border-t border-border/30 text-center">
              <Link to="/register" className="text-xs uppercase tracking-widest text-primary hover:underline font-semibold">
                Register to View Price
              </Link>
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};